module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-selling green",
    attrs: {
      "id": 'gd-selling-' + _vm.num
    }
  }, _vm._l((_vm.cat), function(cato, catIndex) {
    return (cato.index_page_category_id == _vm.num) ? _c('div', {
      key: catIndex
    }, [_c('h3', {
      staticClass: "mod-selling-title"
    }, [_c('span', [_vm._v(_vm._s(cato.content))])]), _vm._v(" "), _c('div', {
      staticClass: "mod-common"
    }, [_c('div', {
      staticClass: "col-menu"
    }, [_c('strong', [_vm._v("最热HOT")]), _vm._v(" "), _vm._l((cato.childrean), function(cato1) {
      return _c('router-link', {
        key: cato1.key,
        attrs: {
          "to": cato1.to,
          "target": "_blank"
        }
      }, [_vm._v("\n\t\t            \t\t\t" + _vm._s(cato1.content) + "\n\t\t            \t\t")])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "col-img"
    }, _vm._l((_vm.adv), function(item, index) {
      return (index == 0) ? _c('router-link', {
        key: index,
        attrs: {
          "to": item.to,
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": item.atturl,
          "alt": item.aname,
          "height": "474px",
          "width": "192px"
        }
      })]) : _vm._e()
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "col-goods"
    }, [_c('ul', {
      staticClass: "clearfix"
    }, [_vm._l((_vm.goods1), function(item, index) {
      return (index == 0) ? _c('li', {
        key: item.key + 100,
        staticClass: "double"
      }, [_c('router-link', {
        staticClass: "col-goods-item",
        attrs: {
          "to": item.to,
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": item.atturl,
          "alt": item.aname,
          "height": "236px",
          "width": "395px"
        }
      })])], 1) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.goods2), function(item, index) {
      return (index < 5) ? _c('li', {
        key: item.key
      }, [_c('router-link', {
        staticClass: "col-goods-item",
        attrs: {
          "to": item.to,
          "target": "_blank"
        }
      }, [_c('img', {
        attrs: {
          "src": item.atturl,
          "alt": item.aname,
          "height": "236px",
          "width": "197px"
        }
      })])], 1) : _vm._e()
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-swipe"
    }, [_c('div', {
      key: 1,
      staticClass: "col-swipe-image"
    }, [_c('div', {
      staticClass: "swipe-wrap"
    }, [_c('div', {
      staticClass: "swipe",
      attrs: {
        "id": "colswiper-image1"
      }
    }, [_c('Carousel', {
      attrs: {
        "autoplay": _vm.setting.autoplay,
        "autoplay-speed": _vm.setting.autoplaySpeed,
        "dots": _vm.setting.dots,
        "radius-dot": _vm.setting.radiusDot,
        "trigger": _vm.setting.trigger,
        "arrow": _vm.setting.arrow
      },
      model: {
        value: (_vm.value1),
        callback: function($$v) {
          _vm.value1 = $$v
        },
        expression: "value1"
      }
    }, _vm._l((_vm.banners1), function(item) {
      return _c('CarouselItem', {
        key: item.key
      }, [_c('div', [_c('router-link', {
        attrs: {
          "to": item.to,
          "target": "_blank"
        }
      }, [_c('img', {
        staticClass: "scrollLoading",
        attrs: {
          "src": item.atturl,
          "alt": item.aname
        }
      })])], 1)])
    }), 1)], 1)])]), _vm._v(" "), _c('div', {
      key: 2,
      staticClass: "col-swipe-goods"
    }, [_c('div', {
      staticClass: "swipe-wrap"
    }, [_c('div', {
      staticClass: "swipe",
      attrs: {
        "id": "colswiper-goods1"
      }
    }, [_c('Carousel', {
      attrs: {
        "autoplay": _vm.setting.autoplay,
        "autoplay-speed": _vm.setting.autoplaySpeed,
        "dots": _vm.setting.dots,
        "radius-dot": _vm.setting.radiusDot,
        "trigger": _vm.setting.trigger,
        "arrow": _vm.setting.arrow
      },
      model: {
        value: (_vm.value2),
        callback: function($$v) {
          _vm.value2 = $$v
        },
        expression: "value2"
      }
    }, _vm._l((_vm.banners2), function(item, index) {
      return _c('CarouselItem', {
        key: item.key
      }, [_c('div', _vm._l((item.children), function(item2) {
        return _c('router-link', {
          key: item2.aid,
          attrs: {
            "to": item2.to,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": item2.atturl,
            "alt": item2.aname,
            "width": "143px",
            "height": "143px"
          }
        })])
      }), 1)])
    }), 1)], 1)])])])])]) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-260350b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/self-owned-mall/index/gd-selling-item.vue
// module id = 1553
// module chunks = 1